export const BUILD_INFO = {
  buildId: '181040',
  commit: 'b255212'
};
